// src/app/providers/AuthProvider.jsx
// GHL Legacy — passthrough auth provider (no Cognito).

import React, { createContext, useContext } from "react";

export const COGNITO_ENABLED = false;

const AuthContext = createContext(null);

const PASSTHROUGH = {
  user: null,
  isAuthenticated: false,
  loading: false,
  signUp: async () => {},
  signIn: async () => {},
  signOut: () => {},
  confirmSignUp: async () => {},
  forgotPassword: async () => {},
  confirmForgotPassword: async () => {},
  getIdToken: () => null,
};

export function AuthProvider({ children }) {
  return (
    <AuthContext.Provider value={PASSTHROUGH}>{children}</AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext) || PASSTHROUGH;
}
